import { c as _c } from "react/compiler-runtime";
import { MiniPopoverPropertiesType } from "@website/ui/mini-popover/mini-popover.types";
import pick from "lodash-es/pick";
import { MouseEvent, RefObject, useEffect, useEffectEvent, useState } from "react";
export const useShow = (properties, popoverReference) => {
  const $ = _c(26);
  const {
    id,
    animate,
    open,
    onClose
  } = properties;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [animateOpen, setAnimateOpen] = useState(false);
  const closePopover = useEffectEvent(onClose);
  let t0;
  if ($[0] !== animate || $[1] !== closePopover || $[2] !== open || $[3] !== popoverReference) {
    t0 = () => {
      let animationTimeout;
      const checkIfClickedOutside = t1 => {
        const {
          target
        } = t1;
        if (open && popoverReference.current && !popoverReference.current.contains(target as Node)) {
          closePopover();
        }
      };
      if (document) {
        if (open) {
          document.addEventListener("click", checkIfClickedOutside, true);
          setPopoverOpen(true);
          animationTimeout = setTimeout(() => {
            setAnimateOpen(true);
          }, 0);
        } else {
          document.removeEventListener("click", checkIfClickedOutside, true);
          setAnimateOpen(false);
          animationTimeout = setTimeout(() => {
            setPopoverOpen(false);
          }, animate === "normal" ? 0 : 150);
        }
      }
      return () => {
        if (animationTimeout !== undefined) {
          clearTimeout(animationTimeout);
        }
        if (document) {
          document.removeEventListener("click", checkIfClickedOutside, true);
        }
      };
    };
    $[0] = animate;
    $[1] = closePopover;
    $[2] = open;
    $[3] = popoverReference;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== animate || $[6] !== open || $[7] !== popoverReference) {
    t1 = [animate, open, popoverReference];
    $[5] = animate;
    $[6] = open;
    $[7] = popoverReference;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  useEffect(t0, t1);
  let t2;
  if ($[9] !== onClose) {
    t2 = event => {
      event.stopPropagation();
      onClose();
    };
    $[9] = onClose;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const onCloseButtonClick = t2;
  const stopPropagationOnModal = _temp;
  let t3;
  if ($[11] !== properties) {
    t3 = pick(properties, "aria-labelledby", "aria-describedby");
    $[11] = properties;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== id || $[14] !== t3) {
    t4 = {
      ...t3,
      "aria-modal": true,
      onClick: stopPropagationOnModal,
      role: "dialog",
      tabIndex: 0,
      id
    };
    $[13] = id;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = animate === "normal" ? 0 : 75;
  let t6;
  if ($[16] !== t5) {
    t6 = {
      timeout: t5
    };
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== onCloseButtonClick) {
    t7 = {
      onClick: onCloseButtonClick
    };
    $[18] = onCloseButtonClick;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== animateOpen || $[21] !== popoverOpen || $[22] !== t4 || $[23] !== t6 || $[24] !== t7) {
    t8 = {
      popoverProperties: t4,
      transitionProps: t6,
      closeButtonProps: t7,
      popoverOpen,
      animateOpen
    };
    $[20] = animateOpen;
    $[21] = popoverOpen;
    $[22] = t4;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
function _temp(event_0) {
  event_0.stopPropagation();
}